// extracted by mini-css-extract-plugin
export default {"wrapper":"Confetti_wrapper__cWq4O"};